import Media from './Media'
import Image from './Image'
import Video from './Video'

export default Object.assign(Media, { Image, Video })
